export default "__VITE_ASSET__DLS2soD0__"